<template>
	<v-footer color="#3A75A0" height="50">
		<v-col class="text-center" cols="12">
			© 2022 SoraSystem
		</v-col>
	</v-footer>
</template>
<script>
	export default {
		name: 'footer-comp',

		data: () => ({

		}),
	}
</script>